var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',[_c('el-carousel',{attrs:{"height":"340px"}},_vm._l((_vm.carousel),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.$store.state.baseUrl+item.path,"alt":""}})])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aebe060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = null
// module chunks = 